import Vue from 'vue';

// 导入全局组件
import scrollDiv from "src/components/global/scrollDiv.vue"      //滚动组件
import pagination from "src/components/global/pagination.vue"    //分页组件
import limitOption from "src/components/global/limitOption.vue"  //限制字数显示的option
import noData from "src/components/global/noData.vue"            //列表无数据提示
import lazyImg from "src/components/global/lazyImg.vue"          //懒加载图片组件
import windowPop from "src/components/global/windowPop.vue"      //弹窗组件

// 基础页面
import basePage from 'src/components/global/basePage.vue'  //后台基础风格页
import backForm from 'src/components/global/backForm.vue'  //后台表单

Vue.component('z-scrollDiv', scrollDiv);
Vue.component('z-pagination', pagination);
Vue.component('z-limitOption', limitOption);
Vue.component('z-noData', noData);
Vue.component('z-lazyImg', lazyImg);
Vue.component('z-windowPop', windowPop);

Vue.component('z-basePage', basePage);
Vue.component('z-backForm',backForm);



// WEBPACK FOOTER //
// ./src/config/global-component.js